import { render, staticRenderFns } from "./FlightsProvider.vue?vue&type=template&id=23c576e6&"
import script from "./FlightsProvider.vue?vue&type=script&lang=js&"
export * from "./FlightsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports